export const container = "c1s4mbgy";
export const sectionContainer = "sz5qfah";
export const contentContainer = "chicw7m";
export const stickyContainer = "s1p79aie";
export const imageParent = "im1gye6";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");